import UploadedArtworks from "@/pages/onboarding/uploaded-artworks";

/**
 * Componente índice para /gallery-onboarding.
 * Reutiliza tal cual tus listas existentes (mismos cards/labels).
 * Orden: primero Pending/Uploaded (con Drafts), luego Verified.
 */
export default function AllArtworks() {
  return (
    <>
      <UploadedArtworks />
    </>
  );
}
